import { type Progress } from "@/libs/request/fetch-progress"
import {
  create,
  type Dependencies,
  type Output as Illumination,
  type Model,
  type Input as ModelInput,
} from "./illumination.model"

export enum MESSAGE_TYPE {
  PROGRESS = "progress",
  READY = "ready",
  RESULT = "result",
}

export type ProgressMessage = { type: MESSAGE_TYPE.PROGRESS; progress: Progress }
export type ReadyMessage = { type: MESSAGE_TYPE.READY }
export type ResultMessage = { type: MESSAGE_TYPE.RESULT; timestamp: number; result: Illumination }
export type Message = ProgressMessage | ReadyMessage | ResultMessage

export enum EVENT_TYPE {
  INIT = "init",
  DATA = "data",
}

export type InitEvent = {
  type: EVENT_TYPE.INIT
  dependencies: Dependencies
}
export type DataEvent = { type: EVENT_TYPE.DATA; timestamp: number } & ModelInput
export type Event = InitEvent | DataEvent

let model: Model | null = null

const handleInit = async (e: InitEvent) => {
  model = await create(e.dependencies, {
    onProgress: (progress) =>
      self.postMessage({ type: MESSAGE_TYPE.PROGRESS, progress } satisfies ProgressMessage),
  })

  self.postMessage({ type: MESSAGE_TYPE.READY } satisfies ReadyMessage)
}
const handlePredict = async (e: DataEvent) => {
  if (!model) throw new Error("Illumination Worker: Model is not initialized")
  self.postMessage(
    {
      type: MESSAGE_TYPE.RESULT,
      timestamp: e.timestamp,
      result: await model.predict(e),
    } satisfies ResultMessage,
    { transfer: [e.frame.data.buffer] },
  )
}

self.onmessage = async (e: MessageEvent<Event>) => {
  if (e.data.type === EVENT_TYPE.INIT) handleInit(e.data)
  else if (e.data.type === EVENT_TYPE.DATA) handlePredict(e.data)
  else {
    let event: string

    try {
      event = JSON.stringify(e.data)
    } catch {
      event = String(e.data)
    }

    console.warn(`[LIQA] Illumination worker: Unknown event ${event}`)
  }
}
